import { yupResolver } from '@hookform/resolvers/yup';
import Button from 'Components/Button';
import ButtonMap from 'Components/ButtonMap';
import Card from 'Components/Card';
import ControllerSelect from 'Components/ControllerSelect';
import ControllerTextArea from 'Components/ControllerTextArea';
import Label from 'Components/Label';
import Domicilio from 'Modules/Main/Clientes/Domicilio';
import General from 'Modules/Main/Clientes/General';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import CobranzaService from 'Services/Http/Cobranza.service';
import CreditoService from 'Services/Http/Credito.service';
import { RegistroVisitaSchema } from 'Services/yup/form';
//import CreditoService from 'Services/Http/Credito.service';

const VisitaComponente = () => {
  const { id } = useParams();
  useEffect(() => {
    if (id) {
      orderData();
    }
  }, [id]);

  const idProspecto = useSelector((state) => state.prospecto?.id);
  const idExpediente = useSelector((state) => state.expediente?.expediente?.id);
  const [idPersona, setIdPersona] = useState('');
  const [expedienteData, setExpedienteData] = useState({});
  const [showData, setShowData] = useState(false);
  const [visitas, setVisitas] = useState([]);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const orderData = async () => {
    try {
      if (id in idProspecto) {
        setIdPersona(idProspecto[id]);
        getPerson();
        getVisitas(idProspecto[id]);
      } else {
        navigate('/main');
      }
    } catch (e) {
      console.log(e);
    }
  };

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      tipoPersona: '',
      descripcion: ''
    },
    resolver: yupResolver(RegistroVisitaSchema)
  });

  const getPerson = async () => {
    setShowData(false);
    try {
      const expedienteData = await CreditoService.expediente(idProspecto[id], idExpediente);
      setExpedienteData(expedienteData.data);
      setShowData(true);
    } catch (e) {
      console.log(e);
    }
  };

  const getVisitas = async () => {
    try {
      const response = await CobranzaService.getVisitas(idProspecto[id]);
      const rows = response.data;
      let data = rows.map((item, index) => (
        <tr
          key={'clientes-row-' + index}
          className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
          <td className="px-6 py-4">{item.descripcionTipoPersona}</td>
          <td className="px-6 py-4">{item.idCredito}</td>
          <td className="px-6 py-4">
            <ButtonMap latitude={item.latitude} longitude={item.longitude} />
          </td>
          <td className="px-6 py-4">{item.descripcion}</td>
          <td className="px-6 py-4">
            {item.created_at
              ? moment(item.created_at).subtract('6', 'hours').format('DD/MM/YYYY HH:mm:ss')
              : ''}
          </td>
        </tr>
      ));
      setVisitas(data);
    } catch (e) {
      console.log(e);
    }
  };

  const getUserLocation = async () => {
    try {
      if (navigator.geolocation) {
        return new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              const { latitude, longitude } = position.coords;
              const formData = { idExpediente, idPersona, latitude, longitude };
              resolve(formData);
            },
            (error) => {
              console.error('Error get user location: ', error);
              setErrorMessage('Se requieren permiso para acceder a la GEOLOCALIZACION');
              reject(error);
            }
          );
        });
      } else {
        console.log('Geolocation is not supported by this browser');
        setErrorMessage('La GEOLOCALIZACION no es soportada por el navegador');
      }
    } catch (e) {
      setErrorMessage('No tiene permisos para el acceso a la geolocalizacion');
    }
  };

  const submit = async (data) => {
    setLoader(true);
    try {
      const location = await getUserLocation();
      const formData = { ...data, ...location };
      await CobranzaService.saveVisit(formData);
      reset();
      getVisitas();
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  return (
    <>
      <Label text={'Visita a domicilio'} />
      <div className="grid grid-cols-2 lg:grid-cols-2 gap-2">
        {showData && idExpediente && idPersona && expedienteData ? (
          <>
            <General idPersona={idPersona} idExpediente={idExpediente} showEjecutivo={false} />
            <Domicilio
              id={expedienteData.idDomicilio}
              idPersona={idPersona}
              idExpediente={idExpediente}
              location={{ longitude: expedienteData.longitude, latitude: expedienteData.latitude }}
            />
            <Card title={'Registrar Visita'} className="col-span-2 lg:col-span-1">
              <form autoComplete="false">
                <div className="w-full py-5 space-y-4 flex flex-col">
                  <div className="w-full space-y-4 flex flex-col">
                    <ControllerSelect
                      data={[
                        { value: '3', label: 'Cliente' },
                        { value: '4', label: 'Aval' },
                        { value: '5', label: 'Referencia' }
                      ]}
                      control={control}
                      name="tipoPersona"
                      error={errors?.tipoPersona}
                      label="Seleccionar visita"
                    />
                    <ControllerTextArea
                      control={control}
                      name="descripcion"
                      error={errors?.descripcion}
                      placeholder="Descripcion"
                    />
                  </div>
                  {errorMessage ? '' : <div className="text-red-600">{errorMessage}</div>}
                </div>
                <div className="w-full space-y-2 flex flex-col lg:w-1/2 xl:w-1/4 lg:flex-row lg:space-y-0 lg:space-x-3">
                  <Button
                    onClick={handleSubmit(submit)}
                    label="Guardar"
                    color="primary"
                    type="button"
                    loading={loader}
                  />
                  <Button onClick={reset} label="Limpiar" type="button" />
                </div>
              </form>
            </Card>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg col-span-2 lg:col-span-1">
              <table className="w-full text-sm text-left rtl:text-right text-black">
                <thead className="text-xs text-white uppercase bg-blue-500">
                  <tr>
                    <th scope="col" className="px-6 py-3">
                      Visita
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Credito
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Ubicación
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Observaciones
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Fecha y hora
                    </th>
                  </tr>
                </thead>
                <tbody>{visitas}</tbody>
              </table>
            </div>
          </>
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default VisitaComponente;
